module.exports = __webpack_public_path__ + "static/Csdap-543c67f31e8912c74eb915d8375dbaa4.jpg";